import { TenantDetails } from '@unistocks/features/admin/components/tenant-management/tenant-details';
import { t } from '@unistocks/shared/localization/index.ts';
import { useLocalSearchParams } from 'expo-router';
import Head from 'expo-router/head';

export default function TenantDetailsScreen() {
  const { id } = useLocalSearchParams<{ id: string }>();

  return (
    <>
      <Head>
        <title>{t('AbpTenantManagement::Tenants')}</title>
      </Head>
      <TenantDetails id={id} />
    </>
  );
}
